import React from 'react';
import { WrapperListFiles, ButtonFiles } from './style';
import { handleUploadFile } from '../../../functions/SincronizaNFe/handleUploadFile';
import { handleDeleteFile } from '../../../functions/SincronizaNFe/handleDeleteFile';

export default function UploadFiles({ files, setFiles, userInfo, totalRateio, setAnexoAlert, setErrorUploads }) {
  return (
    <div>
      <WrapperListFiles>
        {files.map((fileArray, index) => (
          <div key={index + 1}>
            <a href={fileArray.link} target="_blank" rel="noreferrer">
              {fileArray.name}
            </a>
            <button
              onClick={() => {
                handleDeleteFile(fileArray.key, index, files, setFiles, userInfo);
              }}
            >
              Remover
            </button>
          </div>
        ))}
      </WrapperListFiles>
      {totalRateio !== 100 ? (
        <ButtonFiles>
          <button onMouseEnter={() => setAnexoAlert(true)} onMouseLeave={() => setAnexoAlert(false)}>
            Anexo inativo
          </button>
        </ButtonFiles>
      ) : files.length >= 10 ? (
        <ButtonFiles>
          <button>Ops... Você já esta no limite de itens anexados</button>
        </ButtonFiles>
      ) : files.length > 0 ? (
        <ButtonFiles>
          <button>Para anexar novos itens, remova os que já estão anexados.</button>
        </ButtonFiles>
      ) : (
        <ButtonFiles>
          <label onMouseEnter={() => setAnexoAlert(true)} onMouseLeave={() => setAnexoAlert(false)} htmlFor="files">
            Anexar arquivo
          </label>
          <input
            id="files"
            name="files"
            type="file"
            accept=".pdf"
            multiple
            onChange={(e) => handleUploadFile(e.target.files, userInfo, setFiles, setErrorUploads)}
          />
        </ButtonFiles>
      )}
    </div>
  );
}
